import http from "./client";

interface IDicitonariesQueryParams {
  language?: 'list'
  currency?: 'list'
  paymentsystems?: 'list'

  group_id?: string | number;
}


export async function dictionries(queryParams: IDicitonariesQueryParams) {
  const res = await http.get('/api/XHR/get', {
    params: queryParams,
  });


  return res.data;
}